import { create } from "zustand";
import { downloadDocument, type DocumentResource } from "@/lib/document-resource";

export const useDocumentPreviewStore = create<{
  resource: DocumentResource | null;
  show: (resource: DocumentResource) => void;
  close: () => void;
}>((set) => ({ resource: null, show: resource => set({ resource }), close: () => set({ resource: null }) }));

export async function openDocumentResource(resource: DocumentResource): Promise<void> {
  if (resource.previewable) useDocumentPreviewStore.getState().show(resource);
  else await downloadDocument(resource);
}
